export const applyListInfoAction= (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }